import { render, staticRenderFns } from "./attendance-class.vue?vue&type=template&id=5d908653&scoped=true"
import script from "./attendance-class.vue?vue&type=script&lang=js"
export * from "./attendance-class.vue?vue&type=script&lang=js"
import style0 from "./attendance-class.vue?vue&type=style&index=0&id=5d908653&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d908653",
  null
  
)

export default component.exports